module.exports = __webpack_public_path__ + "static/media/sc3.c384f256.jpg";